import { useEffect, useState } from "react";
import useAxios from "../../../../Hooks/useAxios";
import useApp from "../../../../Hooks/useApp";

const initDoc = [];

function useTable() {
  const [limit, setLimit] = useState(10);
  const [docs, setDocs] = useState(initDoc);
  const [isLoading, setIsLoading] = useState(true);
  const [isFiltered, setIsFiltered] = useState(false);
  const request = useAxios();

  const { user } = useApp();

  // Pagination
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);

  const [order, setOrder] = useState("id-desc");

  const refetchDocs = () => getDocs({ page: page, limit: limit });

  const [expenseId, setExpenseId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showApprove, setShowApprove] = useState();

  useEffect(() => {
    getDocs({ page, limit });
  }, [page, limit, order]);

  async function getDocs({ page, limit }) {
    let res = await request({
      method: "GET",
      url: "other-expenses/all-expenses",
      params: {
        page,
        limit,
        order,
      },
      show_loading: false,
      loadingFunc: setIsLoading,
    });

    if (res === "error") {
      return;
    }

    setTotal(res?.pagination?.total || 0);
    setPages(res?.pagination?.pages || 0);
    setHasNextPage(res?.pagination?.hasNextPage || false);
    setHasPrevPage(res?.pagination?.hasPrevPage || false);
    setDocs(res?.docs || initDoc);
  }

  async function clearFilters() {
    setIsFiltered(false);
    refetchDocs();
  }

  function handleNext() {
    if (hasNextPage) {
      setPage((prevPage) => prevPage + 1);
    }
  }

  function handlePrev() {
    if (hasPrevPage) {
      setPage((prevPage) => prevPage - 1);
    }
  }

  async function handleDelete() {
    let res = await request({
      method: "DELETE",
      url: `other-expenses/delete/${expenseId}`,
    });

    if (res !== "error") {
      setShowDeleteModal(false);
      refetchDocs();
    }
  }

  async function handleApprove() {
    let res = await request({
      method: "PUT",
      url: "other-expenses/approve",
      params: {
        id: parseInt(expenseId),
        approved_by: parseInt(user?.id),
      },
    });

    if (res !== "error") {
      setShowApprove(false);
      refetchDocs();
    }
  }

  return {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    isFiltered,
    setIsFiltered,
    pagination: {
      page,
      total,
      pages,
      hasNextPage,
      hasPrevPage,
      handleNext,
      handlePrev,
      limit,
      setLimit,
      total_docs: docs.length || 0,
    },
    setOrder,
    clearFilters,
    expenseId,
    setExpenseId,
    refetchDocs,
    showDeleteModal,
    setShowDeleteModal,
    showApprove,
    setShowApprove,
    handleDelete,
    handleApprove,
  };
}

export default useTable;
